import React, { useState, useEffect } from "react";
import Loading from "../layout/Loading";
import Pagination from "../layout/Pagination";
import { toast } from "react-toastify";
import { getAllPromoCode } from "../../actions/PromoCodeAction";
import PromoCodeTable from "./PromoCodeTable";
import SearchBar from "../layout/SearchBar";
import { ReactComponent as GroupIcon } from '../../assets/admin/Group.svg';

const PromoCodeTableOverview = ({ onEditClick, searchTerm, setSearchTerm }) => {
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");
  const [showColumnPopup, setShowColumnPopup] = useState(false);
  // Import all headers from PromoCodeTable
  const PROMO_TABLE_HEADERS = [
    { key: "retailerId", label: "Retailer ID" },
    { key: "retailerName", label: "Retailer name" },
    { key: "retailerEmail", label: "Email address" },
    { key: "code", label: "Referral code" },
    { key: "totalCustomers", label: "No of customers" },
    { key: "totalSales", label: " Total sales" },
    { key: "action", label: "Action", isAction: true },
  ];
  const TABLE_HEADERS = PROMO_TABLE_HEADERS;
  const [selectedColumns, setSelectedColumns] = useState(TABLE_HEADERS.map(h => h.key));
  const [tempColumns, setTempColumns] = useState(TABLE_HEADERS.map(h => h.key));
  const handleColumnToggle = (key) => {
    setTempColumns(cols =>
      cols.includes(key)
        ? cols.filter(col => col !== key)
        : [...cols, key]
    );
  };
  const handleResetColumns = () => {
    setTempColumns(TABLE_HEADERS.map(h => h.key));
  };
  const handleApplyColumns = () => {
    setSelectedColumns(tempColumns);
    setShowColumnPopup(false);
  };
  const handleSearch = () => {
    setSearchTerm(localSearchTerm);
  };
  const fetchPromoCodeData = async (search, currentPage, itemsPerPage) => {
    const pagination = {
      page: currentPage,
      limit: itemsPerPage,
    };
    // console.log("Fetching banners with currentPage:", page,limit);
    try {
      setLoading(true);

      const response = await getAllPromoCode({
        pagination,
        searchTerm: search,
      });
      // console.log("Response from API:", response);

      if (response.success) {
        setPromoCode(response.data);
        setTotalPages(response.totalPages || 1);
        setTotalCount(response.totalCount || 0);
        setCurrentPage(response.currentPage || currentPage);
      } else {
        toast.error(response.message || "Failed to fetch banner data.");
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
      toast.error("Failed to load banners. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // console.log("promo", promoCode);

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchPromoCodeData(searchTerm, currentPage, itemsPerPage);
  }, [searchTerm, currentPage, itemsPerPage]);
  return (
    <div>
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {/* Desktop/tablet view */}
          <div className="hidden md:flex justify-end items-center py-6 px-4 sm:px-6 ">
            <SearchBar
              searchTerm={localSearchTerm}
              onChange={(value) => setLocalSearchTerm(value)}
              onSearch={handleSearch}
              className="w-96"
            />
          </div>
          {/* Mobile view */}
          <div className="flex md:hidden flex-row items-center w-full gap-2 pt-3 mb-4">
            <div className="flex-1 flex items-center h-9">
              <SearchBar
                searchTerm={localSearchTerm}
                onChange={(value) => setLocalSearchTerm(value)}
                onSearch={handleSearch}
                className="w-full"
              />
            </div>
            <div className="flex items-center">
              <button
                className="flex items-center justify-center h-9 p-0"
                aria-label="Group"
                style={{ minWidth: 40, borderRadius: '6px', border: '1px solid #E5E7EB', background: '#FFF', boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}
                onClick={() => setShowColumnPopup(true)}
              >
                <GroupIcon className="w-6 h-6 text-gray-500" />
              </button>
            </div>
            {/* Mobile group modal with requested style */}
            {showColumnPopup && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" onClick={() => setShowColumnPopup(false)}>
                <div className="bg-white rounded-lg p-6 w-80 max-w-sm shadow-lg" onClick={e => e.stopPropagation()}>
                  <h2 className="text-lg font-semibold mb-4">Edit columns</h2>
                  <div className="flex flex-col mb-4">
                    {TABLE_HEADERS.map((header, idx) => (
                      <React.Fragment key={header.key}>
                        <label className="flex items-center gap-2 text-base py-2">
                          <input
                            type="checkbox"
                            checked={tempColumns.includes(header.key)}
                            onChange={() => handleColumnToggle(header.key)}
                            className="accent-primary w-4 h-4"
                          />
                          <span>{header.label} <span className="text-xs text-gray-400"></span></span>
                        </label>
                        {idx < TABLE_HEADERS.length - 1 && (
                          <hr className="border-t border-gray-200" />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="mt-6 flex justify-between gap-2">
                    <div className="flex justify-end gap-2 mt-2 w-full">
                      <button
                        onClick={handleResetColumns}
                        className="border border-gray-300 rounded-md px-4 py-2 text-sm font-medium bg-white text-gray-700"
                      >
                        Reset
                      </button>
                      <button
                        onClick={handleApplyColumns}
                        style={{ backgroundColor: '#22C55E' }}
                        className="text-white rounded-md px-4 py-2 text-sm font-medium"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="md:px-6">
            <PromoCodeTable
              promoCode={promoCode}
              setPromoCode={setPromoCode}
              onEditClick={onEditClick}
              selectedColumns={selectedColumns}
              refreshData={() => fetchPromoCodeData(currentPage, itemsPerPage)}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={handlePageChange}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PromoCodeTableOverview;
